<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Domaine</label>
          <v-select :options="domaine_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="domaineFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Etat</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        
      </div>
    </vx-card>
    <vs-table ref="table"   v-model="selected" @selected="handleSelected" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Ajouter une formation</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="titre">Titre de formation</vs-th>
        <vs-th sort-key="nom_domaine">Domaine</vs-th>
        
        <vs-th sort-key="Salaire_formateur">Groupe</vs-th>
        <vs-th sort-key="etat">Etat</vs-th>
        <vs-th>Action</vs-th>
      </template>
      <!--template slot-scope="{data}"> 
      <div :data="tr" :key="indextr" v-for="(tr, indextr) in data">
      <div v-if="tr.name===domaineFilter.value">{{domaineFilter.value}}</div>
      <vs-tr>
        <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
        </vs-td>
      </vs-tr>
      </div>
      </template-->
      
        <template slot-scope="{data}"> 
          <tbody>
            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-if="(domaineFilter.value==='all' || tr.nom_domaine===domaineFilter.value) && (isVerifiedFilter.value==='all' || tr.active===isVerifiedFilter.value) ">
              <vs-td >
                <p  class="product-titre font-medium truncate">{{ tr.titre }}</p>
              </vs-td>

              <vs-td filter: true>
                <p class="product-nom_domaine"><router-link to="/">{{ tr.nom_domaine }}</router-link></p>
              </vs-td>
              
             

              
              <vs-td>
                <p class="product-prix font-medium truncate">{{ tr.nbr_groupe }} </p>
              </vs-td>
              <vs-td>
                <vs-chip class="ag-grid-cell-chips" :color="chipColor(tr.active)">
                  <div v-if="tr.active=='false'"><span>non participé</span></div>
                  <div v-if="tr.active=='true'"><span>on participation</span></div>
                </vs-chip>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="confirmDeleteRecord(tr.titre,tr.id)" />
              </vs-td>
              
            </vs-tr>
            
          </tbody>
          
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from '../DataViewSidebar.vue'
import moduleformation from '@/store/formation/moduleformation.js'
import moduledomaine from '@/store/domaine/moduledomaine.js'
import vSelect from 'vue-select'
export default {
  components: {
    DataViewSidebar,
    vSelect
  },
  data() {
    return {
      formationtitle:null,
      usersid:null,
      gridApi: null,
      gridOptions: {},
      domaineFilter: { label: 'Toute', value: 'all' },
      isVerifiedFilter: { label: 'Toute', value: 'all' },
      domaineOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' },
      ],
      isVerifiedOptions: [
        { label: 'Toute', value: 'all' },
        { label: 'on participation', value: 'true' },
        { label: 'non participé', value: 'false' },
      ],
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  computed: {
    chipColor() {
            return (value) => {
              if(value === "true") return "success"
              else if(value === "false") return "danger"
              
            }
          },
    domaine_choices() {
        let opts=[];
          for (var users of this.$store.state.domaine.users) {
              opts.push({label: users.nom_domaine, value: users.nom_domaine});
            }
            opts.unshift({ label: 'Toute', value: 'all' });
      return opts
    },
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products() {
      console.log(this.$store.state.formation.users)
      return this.$store.state.formation.users
    },
    queriedItems() {
      
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
     /* let opt=this.products.length;
      for(let i=0;i<this.products.length;i++){
      {   
       if (this.products[0].name===this.domaineFilter.value){opt--}
      }}
      console.log('opt=',opt)
      return opt+1*/
    }
  },
  watch: {
    domaineFilter(obj) {
      //this.setColumnFilter("nom_domaine", obj.value)
    },
    },
  methods: {
    handleSelected(tr) {
      this.$router.push("/application/formation/user-Vview/" + tr.id)
      //this.$router.push("/application/formation/user-Vview/" + this.params.tr.id).catch(() => {})
      
    },
    
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.domaineFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData(data) {
      console.log(data)
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor(status) {
      if(status == 'on_hold') return "warning"
      if(status == 'delivered') return "success"
      if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    confirmDeleteRecord(title,id) {
      this.usersid = id
      this.formationtitle = title
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirmation de la suppression`,
              text: `Vous êtes sur le point de supprimer "${title}"`,
              accept: this.deleteRecord,
              acceptText: "supprimer"
            })
          },
          deleteRecord() {
            /* Below two lines are just for demo purpose */
            //console.log('this.tr.titre',this.tr.titre)
            //this.showDeleteSuccess()
            this.$store.dispatch("formation/removeRecord", this.usersid).then(()   => { this.showDeleteSuccess() }).catch(err => { console.error(err);this.showDeleteeror()       })
            
            
            /* UnComment below lines for enabling true flow if deleting user */
            // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
            //   .then(()   => { this.showDeleteSuccess() })
            //   
          },
          showDeleteeror() {
            this.$vs.notify({
              color: 'danger',
              title: 'Formation pas supprimé',
              text: 'Formation sélectionné pas supprimé'
            })
            
          },
          showDeleteSuccess() {
            this.$vs.notify({
              color: 'success',
              title: 'Formation supprimé',
              text: 'Formation sélectionné a été supprimé avec succès'
            })
            
          }
  },
  created() {
    if(!moduleformation.isRegistered) {
      this.$store.registerModule('formation', moduleformation)
      moduleformation.isRegistered = true
    }
    this.$store.dispatch("formation/fetchUsers")
    if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
   this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
    this.isMounted = true;
  }
}
</script>

<style lang="scss">

.ag-grid-cell-chips {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}

#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-nom {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        padding: 0 15px !important;
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
